import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight } from 'lucide-react';

export default function InternshipPaymentSuccess() {
  const { id } = useParams();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 pt-16">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-card border border-earth-200 rounded-3xl p-10 max-w-md w-full text-center"
      >
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
        <h1 className="text-2xl font-serif font-bold text-earth-900 mb-2">Payment Successful!</h1>
        <p className="text-earth-500 mb-6">
          You're now enrolled. Head to your workspace to start the first task.
        </p>
        <Link
          to={id ? `/internships/${id}/workspace` : '/dashboard'}
          className="inline-flex items-center gap-2 bg-saffron-600 hover:bg-saffron-700 text-white font-bold px-6 py-3 rounded-xl transition-colors"
        >
          Go to Workspace <ArrowRight className="w-4 h-4" />
        </Link>
        <div className="mt-4">
          <Link to="/internships" className="text-sm text-earth-400 hover:text-earth-600 hover:underline">
            Browse more projects
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
